/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import styled from 'styled-components';

export const InfoIconStyles = styled.div`
  margin: 11px;
  display: flex;
  @media all and (max-width: 768px) {
    margin: 7px 11px 0px 5px;
  }
`;

const InfoIcon = () => (
  <InfoIconStyles>
    <svg width="17px" height="17px" margin="11px" xmlns="http://www.w3.org/2000/svg">
      <g id="Cart" stroke="none" strokeWidth="1" fill="rgb(62, 118, 151)" fillRule="evenodd">
        <path
          d="M8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 Z M10,6 L6,6 L6,7 L7,7 L7,12 L6,12 L6,14 L11,14 L11,12 L10,12 L10,6 Z M8.5,2 C7.67157288,2 7,2.67157288 7,3.5 C7,4.32842712 7.67157288,5 8.5,5 C9.32842712,5 10,4.32842712 10,3.5 C10,2.67157288 9.32842712,2 8.5,2 Z"
          id="Combined-Shape"
          fill="white"
        />
      </g>
    </svg>
  </InfoIconStyles>
);

export default InfoIcon;
